import React, { useState } from 'react';
import { sumBy, uniq } from 'lodash';
import { format as formatDate } from 'date-fns';
import { Input } from 'reactstrap';
import numeral from 'numeral';

import firebase from '../firebase';
import useDocumentSubscription from './hooks/useDocumentSubscription';
import useTenant from './hooks/useTenant';
import SettingText from './SettingText';

const db = firebase.firestore();

export default function PurchaseOrderContent (props) {
  const { purchaseOrder, supplier, products, productsById, } = props;
  const { locale, currency } = supplier;
  const bodyProducts = products.filter(_ => _.isBody);
  const displayProducts = bodyProducts.filter(_ => !_.isHidden);
  const displayProductCodePrefixes = uniq(displayProducts.map(_ => _.id.split('-')[0]));
  const tenant = useTenant();
  const currencyFormat = _ => ({
    ja: (<span>&yen;{numeral(_).format('')}</span>),
    en: (<span>{numeral(_).format('$0,0.00')}</span>),
  })[locale];
  const dateFormat = { ja: 'yyyy/MM/dd', en: 'MMM dd, yyyy' }[locale];

  return (
    <div className="purchase-order" style={{ width: 1200, }}>
      <h3 className="font-weight-bold">
        {{ ja: '発注書', en: 'Purchase Order' }[locale]}
      </h3>
      <h5 className="mt-5 font-weight-bold">
        {{ ja: `${supplier?.name} 御中`, en: `TO: ${supplier?.name}`, }[locale]}
      </h5>
      <div className="mt-4 d-flex justify-content-between">
        <div>
          <table className="table border-2 table-bordered table-sm">
            <tbody>
              <tr>
                <th>
                  {{ ja: '発注No.', en: 'PO Number' }[locale]}
                </th>
                <th>
                  {{ ja: '発注日', en: 'PO Date' }[locale]}
                </th>
              </tr>
              <tr>
                <td>
                  {purchaseOrder.poNumber}
                </td>
                <td>
                  {formatDate(new Date(), dateFormat)}
                </td>
              </tr>
            </tbody>
          </table>
          <div>
            <span>
              {{ ja: '希望納期', en: 'Request ETD' }[locale]}
            </span>
            <span className="ml-4 font-weight-bold">
              {purchaseOrder.requestEtd && formatDate(purchaseOrder.requestEtd.toDate(), dateFormat)}
            </span>
          </div>
        </div>
        <div>
          <SettingText name={{ ja: 'poTopRightJa', en: 'poTopRight' }[locale]} />
        </div>
      </div>
      <div className="mt-3">
        <table className="table border-2 table-bordered table-sm">
          <thead className="thead-dark text-center">
            <tr>
              <th>
                {{ ja: '品目No.', en: 'Item No' }[locale]}
              </th>
              <th>
                {{ ja: '説明', en: 'Description' }[locale]}
              </th>
              <th>
                JAN
              </th>
              <th>
                {{ ja: '数量', en: 'Quantity' }[locale]}
              </th>
              <th>
                {{ ja: '価格', en: 'Price' }[locale]}
              </th>
              <th>
                {{ ja: '金額', en: 'Item Total Price' }[locale]}
              </th>
            </tr>
          </thead>
          <tbody>
            {
              Array(20).fill().map((_, i) => {
                const item = purchaseOrder.items[i];
                const { productId, quantity } = item ?? {};
                const product = productsById[productId];
                return (
                  <tr key={i}>
                    <td>
                      {productId}
                      &nbsp;
                    </td>
                    <td>
                      {product?.enName}
                    </td>
                    <td>
                      {product?.jan}
                    </td>
                    <td className="text-right">
                      {product && numeral(quantity).format()}
                    </td>
                    <td className="text-right">
                      {product && currencyFormat(product?.usdPrice)}
                    </td>
                    <td className="text-right">
                      {product && currencyFormat(product?.usdPrice * quantity)}
                    </td>
                  </tr>
                );
              })
            }
            <tr>
              <th colSpan={3} className="text-right">
                {{ ja: '合計', en: 'Total' }[locale]}
              </th>
              <th className="text-right">
                {sumBy(purchaseOrder.items, 'quantity').toLocaleString()}
              </th>
              <th>
              </th>
              <th className="text-right">
                {currencyFormat(sumBy(purchaseOrder.items, _ => productsById[_.productId]?.usdPrice * _.quantity))}
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mt-4">
        <h5>
          {{ ja: '備考', en: 'Request' }[locale]}
        </h5>
        <div className="border p-2" style={{ minHeight: 120, width: '60%', whiteSpace: 'pre-line', }}>
          {purchaseOrder.info}
        </div>
      </div>
    </div>
  );
};
